import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormModel} from '../../../common/components/form/models';
import {SubSink} from '@Common/core/utils/subsink';
import {ActivatedRoute, Router} from '@angular/router';
import {FormulaireService} from '../../../common/services/formulaire/formulaire.service';
import {PubSubService} from '@Common/core/services';
import {finalize} from 'rxjs/operators';
import {FormListRequestersService} from '../../../common/services/requesters-form/requesters-form.service';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '@Common/widgets/general/data-table';
import {FormListRequesters} from '../../../common/services/requesters-form/requesters-form.model';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {RequestersFormComponent} from './requesters-form/requesters-form.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-requesters-list-form',
  templateUrl: './requesters-list-form.component.html',
  styleUrls: ['./requesters-list-form.component.scss']
})
export class RequestersListFormComponent implements OnInit, OnDestroy {
  formModel: FormModel;
  columns: ColumnDataTable[] = [
    {
      columnDef: 'name', header: 'Nom de la liste', display: (row: FormListRequesters) => row.name,
      tooltip: (row: FormListRequesters) => row.name,
      sort: true
    },
    {
      columnDef: 'members', header: 'Nombre de membres',
      display: (row: FormListRequesters) => row.requesters?.length || 0,
      sort: true
    },
  ];
  actions: ActionDataTable[] = [{
    label: 'edition', tooltip: 'Editer la liste des membres',
    icon: 'edit',
    iconcolor: 'accent',
    click: (row: FormListRequesters) => this._editFormListRequesters(row)
  }];
  dsFormListRequesters: MatDataSourceGeneric<FormListRequesters> = new MatDataSourceGeneric<FormListRequesters>();
  extraParams: Map<string, string> = new Map<string, string>();
  countList = -1;
  @ViewChild(DataTableComponent, { static: false }) dataTable: DataTableComponent;
  subSink = new SubSink();
  constructor(public dialog: MatDialog,
              private router: Router, private route: ActivatedRoute,
              private pubSubSvc: PubSubService,
              private formulaireSvc: FormulaireService,
              private formListRequestersSvc: FormListRequestersService) {
    this.dsFormListRequesters.daoService = this.formListRequestersSvc;
  }

  ngOnInit(): void {
    const param = this.route.snapshot.paramMap.get('uuid');
    if (param) {
      this._fetchForm(param);
    }
    this.subSink.sink = this.dsFormListRequesters.listCount$.subscribe(_cnt => this.countList = _cnt);
  }
  public openAddList() {
    const data = {form: this.formModel};
    const dialogRef = this.dialog.open(RequestersFormComponent, {data: data, width: '800px'});
    dialogRef.updatePosition({top: '50px'});
    dialogRef.afterClosed().subscribe(() => this.dataTable.reload());
  }
  private _editFormListRequesters(row: FormListRequesters) {
    this.router.navigate(['requesters-list/members/edit', row.id, this.formModel.uuid], {relativeTo: this.route.parent});
  }
  private _fetchForm(uuid) {
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.formulaireSvc
      .get(uuid)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe(_form => {
        this.extraParams.set('forms_demat', _form.id);
        this.formModel = _form;
      });
  }

  ngOnDestroy(): void {
  }
}
